import {useFormik} from 'formik'
import {IMenu, IMenuFormValues, initMenuFormValues} from '../_modal'
import {KTIcon} from '../../../../../_metronic/helpers'
import {useMutation, useQueryClient} from 'react-query'
import axios from 'axios'
import {BASE_URL} from '../../../config'
import toast from 'react-hot-toast'
import useLinkList from '../../../../hooks/useLinkLIst'
import ReactSelectBox from '../../../../utils/components/ReactSelectBox'
import {useEffect} from 'react'

const CREATE_MENU_URL = ` ${BASE_URL}/api/protect/createMenu`
const UPDATE_MENU_URL = ` ${BASE_URL}/api/protect/updateMenu`

type Props = {
  selectedMenu: IMenu | undefined
  onResetSelect: () => void
}

const MenuForm = ({selectedMenu, onResetSelect}: Props) => {
  const queryClient = useQueryClient()
  const {optionsLink: linkOptions} = useLinkList()

  const {mutateAsync: menuSubmit} = useMutation({
    mutationFn: async (sendvalue: Partial<IMenuFormValues>) => {
      if (selectedMenu) {
        await axios.put(UPDATE_MENU_URL, {...sendvalue, idMenu: selectedMenu.id_menu})
        onResetSelect()
      } else {
        await axios.post(CREATE_MENU_URL, sendvalue)
      }
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfull')
      queryClient.invalidateQueries(['menuItemList'])
      resetForm()
    },
  })

  const formik = useFormik({
    initialValues: initMenuFormValues,
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        const {link, ...sendvalues} = values
        await menuSubmit(sendvalues)
        console.log(values)
      } catch (error) {
        console.log(error)
      }
    },
  })

  const resetForm = () => {
    formik.resetForm()
  }

  const onSelectLink = (id: number) => {
    formik.setFieldValue('linkId', id)
  }

  const getLinkName = (id: number): string => {
    let name = ''
    const selected = linkOptions.find((link) => link.id === id)

    if (selected) {
      name = selected.value
    }

    return name
  }

  useEffect(() => {
    resetForm()
    if (selectedMenu) {
      formik.setValues({
        menuName: selectedMenu.menu_name,
        linkId: selectedMenu.link_id,
        link: getLinkName(selectedMenu.link_id),
        icon: selectedMenu.icon,
        slNo: selectedMenu.sl_no,
      })
    }
  }, [selectedMenu])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Menu Form</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={onResetSelect}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <form onSubmit={formik.handleSubmit}>
              <div className='row row-cols-1'>
                {/* Menu Name */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Menu Name</label>

                    <input
                      {...formik.getFieldProps('menuName')}
                      placeholder='Enter name'
                      type='text'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div>
                </div>

                {/* Link ID */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Link</label>

                    <ReactSelectBox
                      formik={formik}
                      fieldValue='link'
                      placeholder='Select link'
                      setSelect={onSelectLink}
                      options={linkOptions}
                    />
                  </div>
                </div>

                {/* Menu Icon */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Icon</label>

                    <input
                      {...formik.getFieldProps('icon')}
                      placeholder='Enter icon'
                      type='text'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div>
                </div>

                {/* Menu Serial Number */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Serial No.</label>

                    <input
                      {...formik.getFieldProps('slNo')}
                      placeholder='Enter serial number'
                      type='number'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div>
                </div>
              </div>
              <div className='text-center pt-15'>
                <button
                  type='reset'
                  className='btn btn-light me-3 border border-gray-600'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={resetForm}
                >
                  CLOSE
                </button>

                <button
                  type='submit'
                  className='btn btn-primary me-3'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MenuForm
